<template>
  <div class="home">
    <Header class="header" />

    <HomePageOne />
    <RemittanceServicePage />
    <CarouselPage />
    <PaymentPartnersPage />
    <!-- <OnePage /> -->
    <!-- <TwoPage /> -->
    <!-- <ThreePage /> -->
    <CashbackPage />
    <CrossBorderCardPage />
    <GifeCardPage />
    <IntroducePage />
    <LeadershipCarousel />
    <NewsPage />
    <!-- <FourPage />
    <FivePage />
    <SixPage /> -->
    <!-- <SevenPage /> -->
    <!-- <EightPage /> -->
    <FooterSection />
  </div>
</template>

<script>
// @ is an alias to /src
import RemittanceServicePage from "@/components/pagenew/RemittanceServicePage.vue";
import PaymentPartnersPage from "@/components/pagenew/PaymentPartnersPage.vue";
import Header from "@/components/one/header.vue";
import HomePageOne from "@/components/pagenew/HomePageOne.vue";
import CarouselPage from "@/components/pagenew/CarouselPage.vue";
// import OnePage from "@/components/onePage.vue";
// import TwoPage from "@/components/twoPage.vue";
// import ThreePage from "@/components/threePage.vue";
import CashbackPage from "@/components/pagenew/CashbackPage.vue";
import CrossBorderCardPage from "@/components/pagenew/CrossBorderCardPage.vue";
import GifeCardPage from "@/components/pagenew/GifeCardPage.vue";
import IntroducePage from "@/components/pagenew/IntroducePage.vue";
import LeadershipCarousel from "@/components/pagenew/LeadershipCarousel.vue";
import NewsPage from "@/components/pagenew/NewsPage.vue";
// import FourPage from "@/components/fourPage.vue";
// import FivePage from "@/components/fivePage.vue";
// import SixPage from "@/components/sixPage.vue";
// import SevenPage from "@/components/sevenPage.vue";
// import EightPage from "@/components/eightPage.vue";
// import Footer from "@/components/footer.vue";
import FooterSection from "@/components/layout/FooterSection.vue";

export default {
  name: "HomeView",
  components: {
    RemittanceServicePage,
    PaymentPartnersPage,
    Header,
    HomePageOne,
    CarouselPage,
    // OnePage,
    // TwoPage,
    // ThreePage,
    CashbackPage,
    CrossBorderCardPage,
    GifeCardPage,
    IntroducePage,
    LeadershipCarousel,
    NewsPage,
    // FourPage,
    // FivePage,
    // SixPage,
    // SevenPage,
    // EightPage,
    FooterSection,
  },
};
</script>

<style lang="scss" scoped>
.home {
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 109;
  }
}
</style>
